import { Component } from '@angular/core';

@Component({
  selector: 'app-order-card-skeleton',
  templateUrl: './order-card-skeleton.component.html',
})
export class OrderCardSkeletonComponent {}
